//used to load issuer config
export interface EntrustWPPIssuerConfig {
    platform: 'us' | 'eu';
    appleEnabled: boolean;
    partnerId?: string; // for Apple
    googleEnabled?: boolean;
    integratorId?: string; // for Google
    googleOpcEnabled: boolean;
    environment: 'production' | 'test';
    dcsKid: string;
}

//User as config on EntrustWPP constructor
export interface EntrustWPPGoogleConfig {
    saveAnFPan?: boolean; // google optional
    cardDisplayName?: string; // google optional
    lastDigits?: string;
    userAddress?: UserAddress;
    integratorId: string;
}

export interface UserAddress {
    name: string;
    addressLines: string[];
    localityName: string;
    administrativeAreaName: string;
    postalCodeNumber: string;
    countryCode: string; // Country code must be a 2-letter code in accordance with https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2

    phone: string;
}

export interface EntrustWPPAppleConfig {
    cardTemplateIdentifier?: string; //optional
    partnerId?: string;
}

export interface EntrustWPPConfig {
    target: string | Element;
    issuerId: string;
    locale?: string; // optional
    type: 'google' | 'apple';
    issuerPushSessionId?: string; // optional
    google: EntrustWPPGoogleConfig;
    apple: EntrustWPPAppleConfig;
}

export enum Message {
    TECHNICAL_ERROR,
}

export enum MessageOutput {
    OK = 'OK',
    PARTIAL = 'PARTIAL',
    NOT_CONFIRMED = 'NOT_CONFIRMED',
    TOKENIZATION_FAILED = 'TOKENIZATION_FAILED',
    TECHNICAL_ERROR = 'TECHNICAL_ERROR',
    CANCELED = 'CANCELED',
    FAILED = 'FAILED',
    TIMEOUT = 'TIMEOUT',
    NO_ELIGIBLE_DEVICE = 'NO_ELIGIBLE_DEVICE',
    LOGIN_FAILED = 'LOGIN_FAILED',
}

export class WPPError {
    type: string | Message;
    detail: string;
    constructor(type: string | Message, detail?: string) {
        this.type = type;
        this.detail = detail;
    }
}

export interface GetPushOpaqueData {
    (walletOpaqueData: string): Promise<unknown>;
}

export interface OnResult {
    (result: any): void;
}

export interface OnFailure {
    (result: any): void;
}

export interface OnCancel {
    (result: any): void;
}
